import React from 'react';

import { AppointmentRegistrationModal as AppointmentRegistrationModalView } from './appointment-registration-modal';
import { IAppointmentRegistrationModalContainerProps } from './appointment-registration-modal.models';
import { InternalLinks } from '../../../../constants';

export const AppointmentRegistrationModal = (
  props: IAppointmentRegistrationModalContainerProps,
): JSX.Element => {
  const handleRegistrationDone = () => {
    props.onNavigate(InternalLinks.appointment);
  };

  return (
    <AppointmentRegistrationModalView
      {...props}
      onDone={handleRegistrationDone}
    />
  );
};
